import { computed, inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '@auth0/auth0-angular';
import { catchError, map, Observable, of } from 'rxjs';

/**
 * Permissions of the current user, read from the access token.
 */
@Injectable({ providedIn: 'root' })
export class Permissions {
  private authService = inject(AuthService);

  private readonly granted = toSignal(this.get$().pipe(catchError(() => of<string[]>([]))), {
    initialValue: [],
  });

  /** Emits the permissions held in the current access token. */
  get$(): Observable<string[]> {
    return this.authService
      .getAccessTokenSilently()
      .pipe(map((token) => new JwtHelperService().decodeToken(token).permissions ?? []));
  }

  /** Whether the current user holds `permission`. An empty permission is always granted. */
  has(permission: string): Signal<boolean> {
    return computed(() => permission === '' || this.granted().includes(permission));
  }
}
